let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("du7nS")).then(() => parcelRequire('8gyyU'));